let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ha5h")).then(() => parcelRequire('2wveb'));